module.exports = __webpack_public_path__ + "img/laranja.e8cb882a.png";